import { Toast } from "../../js/toast.73af8352e0da.js";
import"../../js/backdrop-dialog.37ba46c3e019.js";

class NYCDOHContactUs {
  constructor() {
    this.elements = this.queryDomElements();
    this.bindEventListeners();
    this.validateForm();
  }

  queryDomElements() {
    const contactUsModal = document.getElementById("pet-contact-us-modal");
    return {
      contactUsModal: contactUsModal,
      submitButton: contactUsModal.querySelector("button[type=submit]"),
      contactForm: document.getElementById("nycdoh-contact-form"),
      contactTopicField: contactUsModal.querySelector(
        "select[name=contact_topic]",
      ),
    };
  }

  validateForm() {
    this.elements.submitButton.disabled =
      !this.elements.contactForm.checkValidity();
  }

  bindEventListeners() {
    this.elements.contactUsModal.addEventListener("htmx:afterOnLoad", () => {
      this.elements.contactUsModal.close();
      const toast = new Toast();
      toast.showToast();
    });

    this.elements.contactForm.addEventListener("input", () => {
      this.validateForm();
    });

    this.elements.contactUsModal.addEventListener("close", () => {
      this.elements.contactForm.reset();
      this.validateForm();
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new NYCDOHContactUs();
});
